import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { IManagedClients } from 'interfaces/HistoricalResults/IManagedClients';
import { HistoricalResultsApis } from 'hooks/apis/HistoricalResultsApis';
import ClientManagement from './components/ClientManagement/ClientManagement';

const HistoricalResultsManagement = () => {
  const { getManagedClients } = HistoricalResultsApis();
  const [managedClients, setManagedClients] = useState<IManagedClients[]>(null);
  const [error, setError] = useState<string>(null);

  useEffect(() => {
    getManagedClients().then((response) => {
      if (response && !response.errorMessage) {
        setManagedClients(response);
      } else {
        setError(response?.errorMessage);
      }
    });
  }, [getManagedClients]);

  return managedClients?.length > 0 ? (
    <Box>
      <h2>Online Results Access Management</h2>
      {error !== null ? <p className="errorMessage">{error}</p> : null}
      {managedClients.map((m) => (
        <ClientManagement key={m.ClRef + m.Branch} clRef={m.ClRef} branch={m.Branch} />
      ))}
    </Box>
  ) : null;
};

export default HistoricalResultsManagement;
